"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MaternityMoments() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const projects = [{
    name: "Golden Hour Glow",
    tag: "MATERNITY · OUTDOOR",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_golden_hour.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_golden_hour.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_golden_hour.png-wvc-sizes",
    height: "h-[420px]"
  }, {
    name: "The Nursery Nook",
    tag: "LIFESTYLE · INTERIOR",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_nursery_details.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_nursery_details.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_nursery_details.png-wvc-sizes",
    height: "h-[320px]"
  }, {
    name: "Anticipation",
    tag: "PORTRAIT · STUDIO",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_portrait_expectant.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_portrait_expectant.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_portrait_expectant.png-wvc-sizes",
    height: "h-[360px]"
  }, {
    name: "Hand in Hand",
    tag: "COUPLE · GARDEN",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_couple_garden.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_couple_garden.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_couple_garden.png-wvc-sizes",
    height: "h-[460px]"
  }, {
    name: "Tiny Details",
    tag: "STILL LIFE · SAGE",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_baby_shoes.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_baby_shoes.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_baby_shoes.png-wvc-sizes",
    height: "h-[300px]"
  }, {
    name: "Morning Light",
    tag: "LIFESTYLE · HOME",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_morning_light.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_morning_light.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_morning_light.png-wvc-sizes",
    height: "h-[380px]"
  }, {
    name: "The Ohlson Legacy",
    tag: "FAMILY · CLASSIC",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_family_legacy.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_family_legacy.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_family_legacy.png-wvc-sizes",
    height: "h-[340px]"
  }, {
    name: "Soft Silhouettes",
    tag: "ARTISTIC · MONO",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_silhouette.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_silhouette.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_silhouette.png-wvc-sizes",
    height: "h-[400px]"
  }, {
    name: "Nature's Embrace",
    tag: "OUTDOOR · WILLOW",
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_nature_embrace.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_nature_embrace.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694181/img/maternity_nature_embrace.png-wvc-sizes",
    height: "h-[320px]"
  }];
  return <section data-section-id="2251" id="maternity-moments" className="bg-background text-foreground py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        {}
        <div ref={ref} className={`mb-12 md:mb-16 flex flex-col gap-6 md:flex-row md:items-end md:justify-between transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex-1 relative">
            <span className="absolute -top-12 -left-4 font-serif text-[120px] opacity-5 select-none pointer-events-none">O</span>
            <p className="font-default text-xs font-bold uppercase tracking-[0.2em] text-primary mb-5">
              The Gallery
            </p>
            <h2 className="font-serif font-default text-4xl md:text-5xl lg:text-[56px] leading-[1.1] tracking-tight text-foreground">
              Maternity Moments.
            </h2>
          </div>
          <div className="md:pb-3">
            <Link to="/OurJourneyPage" className="inline-flex items-center gap-2 text-sm font-default font-semibold text-primary border-b border-primary/30 pb-1 hover:border-primary transition-colors group">
              <span>View Our Journey</span>
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        {}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {projects.map((project, i) => <div data-index={i} key={i} className="mb-5 break-inside-avoid group relative overflow-hidden rounded-md border border-border bg-card shadow-md">
              <div className={`relative ${project.height} overflow-hidden`}>
                <img src={project.src} data-wvc-srcset={project.srcset} data-wvc-sizes={project.sizes} alt={project.name} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.02]" />

                {}
                <div className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out">
                  <div className="bg-card/95 backdrop-blur-md px-6 py-5 border-t border-border">
                    <h3 className="font-serif font-default text-xl text-foreground leading-tight mb-1.5">
                      {project.name}
                    </h3>
                    <p className="font-mono text-[11px] font-medium uppercase tracking-[0.16em] text-muted-foreground">
                      {project.tag}
                    </p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}